export default function NoDataRow({ type = "data" }: { type?: string }) {
  return (
    <tr className="text-center">
      <td colSpan={100}>
        <p className="text-muted fst-italic mb-0">No {type}.</p>
      </td>
    </tr>
  );
}
